import axios from 'axios';

const OAUTH_URL = import.meta.env.VITE_SYSTEM_OAUTH_URL;

export const createOAuthSession = (token) =>
  axios
    .post(OAUTH_URL, null, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${token}` },
    })
    .catch(() => {});

export const deleteOAuthSession = () => {
  axios.delete(OAUTH_URL, { withCredentials: true }).catch(() => {});
};
